import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import {
  HireDotNetNumbers,
  HireDotNetProjects,
  HireDotNetIndustry,
} from "../../../app-constants";

function GameNumbers(props) {
  return (
    <section className="awrads_sec p50">
      <Container>
        <Row>
          <Col xs={12} md={4} lg={4}>
            <div className="number_items">
              {HireDotNetProjects}
              <div className="title_numbers">
                30+
                <span>.Net Projects Completed</span>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4}>
            <div className="number_items">
              {HireDotNetNumbers}
              <div className="title_numbers">
                20+
                <span>Number of .Net Developers</span>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4}>
            <div className="number_items">
              {HireDotNetIndustry}
              <div className="title_numbers">
                12+
                <span>Industries Served</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default GameNumbers;
